"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _authContext = require("../authContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Login = function Login() {
  return /*#__PURE__*/_react["default"].createElement(_authContext.AuthConsumer, null, function (_ref) {
    var initiateLogin = _ref.initiateLogin;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-sm btn-primary",
      onClick: function onClick() {
        return initiateLogin("umesh", "kumar", true);
      }
    }, "Login");
  });
};
var _default = Login;
exports["default"] = _default;